import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import i18n from "@/i18n";

let homeLoaded = false;

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/login"
    },

    {
      path: "",
      component: () => import("@/layouts/" + layoutDir() + "/nonportal/Index"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () =>
            import("@/layouts/" + layoutDir() + "/nonportal/pages/login/Login"),
          meta: { authRequired: false, title: "title.login" }
        },
        {
          name: "register",
          path: "/register",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/registration/Registration"
            ),
          meta: { authRequired: false }
        },
        {
          name: "registration",
          path: "/registration",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/registration/Registration"
            ),
          meta: { authRequired: false, title: "title.register" }
        },
        {
          name: "single-sign-on-redirect",
          path: "/sso-redirect",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/SingleSignOnRedirect"
            ),
          meta: { authRequired: false }
        },
        {
          name: "privacystatement",
          path: "/privacystatement",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/overlay/PrivacyStatementPage"
            ),
          meta: { authRequired: false }
        },
        {
          name: "termsandconditions",
          path: "/termsandconditions",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/overlay/TermsAndConditionsPage"
            ),
          meta: { authRequired: false }
        },
        {
          name: "unsubscribe",
          path: "/unsubscribe/:token",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/unsubscribe/Unsubscribe"
            ),
          meta: { authRequired: false }
        },
        {
          name: "RegisterConfirm",
          path: "/register/confirm/:token",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/register-confirm/RegisterConfirm"
            ),
          meta: { authRequired: false }
        },
        {
          name: "InvoiceOnlineRedirect",
          path: "/invoice-online-payment-redirect",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/invoice-online-payment/InvoiceOnlinePaymentRedirect"
            ),
          meta: { authRequired: false }
        },
        {
          name: "InvoiceOnlineResult",
          path: "/invoice-online-payment-result",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/invoice-online-payment/InvoiceOnlinePaymentResult"
            ),
          meta: { authRequired: false }
        },
        {
          name: "reset-password-request",
          path: "/reset-password-request",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/reset-password/Request"
            ),
          meta: { authRequired: false, title: "title.reset_password" }
        },
        {
          name: "reset-password",
          path: "/resetting/reset/:token",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/reset-password/Reset"
            ),
          meta: { authRequired: false, title: "title.reset_password" }
        }
      ]
    },
    {
      path: "/portal",
      component: () =>
        import("@/layouts/" + layoutDir() + "/portal/PortalIndex"),
      children: [
        {
          name: "home",
          path: "/home",
          component: () =>
            import("@/layouts/" + layoutDir() + "/portal/pages/home/Home"),
          meta: { authRequired: true, title: "nav.home" },
          label: "nav.home"
        },
        {
          name: "loading",
          path: "/loading/:intent_route",
          component: () =>
            import("@/layouts/" + layoutDir() + "/portal/pages/Loading"),
          meta: { authRequired: true, title: "message.loading" }
        },
        {
          name: "topupredirect",
          path: "/topupredirect",
          component: () =>
            import("@/layouts/" + layoutDir() + "/portal/pages/TopUpRedirect"),
          meta: { authRequired: true }
        },
        {
          name: "mandate-payment-redirect",
          path: "/mandate-payment-redirect",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/portal/pages/MandatePaymentRedirect"
            ),
          meta: { authRequired: true }
        },
        {
          name: "settings",
          path: "/settings",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/Settings/Settings"
            ),
          meta: { authRequired: true, title: "nav.account_settings" }
        },
        {
          name: "campaigns",
          path: "/campaigns",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/Campaign/Overview"
            ),
          meta: { authRequired: true, title: "nav.campaigns" }
        },
        {
          name: "subscriptions",
          path: "/subscriptions",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/Subscription/Table"
            ),
          meta: {
            authRequired: true,
            title: "nav.subscriptions",
            subscriptionLicenseRequired: true
          }
        },
        {
          name: "invoices",
          path: "/invoices",
          component: () =>
            import("@/layouts/" + layoutDir() + "/portal/pages/Invoice/Table"),
          meta: {
            authRequired: true,
            title: "nav.invoices",
            invoicesShouldBeEnabled: true
          }
        },
        {
          name: "transactions",
          path: "/transactions",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/Transaction/Table"
            ),
          meta: {
            authRequired: true,
            title: "nav.transactions",
            requiresTransactionsTabVisible: true
          }
        },
        {
          name: "transactionview",
          path: "/transactions/:id",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/Transaction/View"
            ),
          meta: {
            authRequired: true,
            title: "nav.transactions",
            requiresTransactionsTabVisible: true
          }
        },
        {
          name: "cashout-requests",
          path: "/cashout-requests",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/CashoutRequest/Table"
            ),
          meta: {
            authRequired: true,
            cashoutLicenseRequired: true,
            title: "nav.cashout_requests"
          }
        },
        {
          name: "cashout-request",
          path: "/cashout-requests/new",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/CashoutRequest/Create"
            ),
          meta: {
            authRequired: true,
            cashoutLicenseRequired: true,
            title: "nav.cashout_requests"
          }
        },
        {
          path: "/auth/privacystatement",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/overlay/PrivacyStatementPage"
            ),
          meta: { authRequired: true, title: "title.privacy_statement" }
        },
        {
          name: "auth_termsandconditions",
          path: "/auth/termsandconditions",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/overlay/TermsAndConditionsPage"
            ),
          meta: { authRequired: true, title: "title.terms_and_conditions" }
        },
        {
          name: "webshop",
          path: "/webshop",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/Webshop/Overview"
            ),
          meta: {
            authRequired: true,
            webshopLicenseRequired: true,
            title: "nav.webshop"
          }
        },
        {
          name: "webshopredirect",
          path: "/webshopredirect",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/portal/pages/Webshop/WebshopRedirect"
            ),
          meta: {
            authRequired: true,
            webshopLicenseRequired: true,
            title: "nav.webshop"
          }
        },
        {
          name: "online-purchases",
          path: "/online-purchases",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/OnlinePurchase/Table"
            ),
          meta: {
            authRequired: true,
            webshopLicenseRequired: true,
            title: "nav.online_purchases"
          }
        },
        {
          name: "online-purchase-view",
          path: "/online-purchase/:external_payment_identifier",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/portal/pages/OnlinePurchase/View"
            ),
          meta: {
            authRequired: true,
            webshopLicenseRequired: true,
            title: "nav.online_purchases"
          }
        }
      ]
    },
    {
      name: "organization-not-found",
      path: "/404",
      component: () => import("@/components/pages/OrganizationNotFoundPage"),
      meta: { authRequired: false }
    },
    {
      path: "/webshop-portal",
      component: () => import("@/layouts/" + layoutDir() + "/webshop/Index"),
      children: [
        {
          name: "webshop-no-login",
          path: "webshop",
          component: () =>
            import(
              "@/layouts/" + layoutDir() + "/nonportal/pages/Webshop/Overview"
            ),
          meta: {
            authRequired: false,
            webshopLicenseRequired: true,
            title: "nav.webshop"
          }
        },
        {
          name: "webshop-redirect-no-login",
          path: "webshopredirect",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/Webshop/WebshopRedirect"
            ),
          meta: {
            authRequired: false,
            webshopLicenseRequired: true,
            title: "nav.webshop"
          }
        },
        {
          name: "webshop-integrator-order",
          path: "webshop/:product_uuid",
          component: () =>
            import(
              "@/layouts/" +
                layoutDir() +
                "/nonportal/pages/webshop-order/WebshopOrder"
            ),
          meta: { authRequired: false, title: "nav.webshop" }
        }
      ]
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const main_page = store.state.config.main_page || "home";
  let loyalty_page_title =
    store.state.config.template_settings.page_title || store.state.config.name;
  let page_name = i18n.t(to.meta.title);
  document.title = `${loyalty_page_title} - ${page_name}`;
  if (to.meta.authRequired && !localStorage.getItem("authorized")) {
    next(!from.meta.authRequired ? from : "/login");
    return;
  }
  if (!to.meta.authRequired && localStorage.getItem("authorized")) {
    next(from.meta.authRequired ? from : { name: main_page });
    return;
  }
  if (
    to.meta.cashoutLicenseRequired &&
    !store.state.config.has_cashout_license
  ) {
    next(from.meta.cashoutLicenseRequired ? from : { name: main_page });
    return;
  }
  if (
    to.meta.subscriptionLicenseRequired &&
    !(
      store.state.config.organization_loyalty_settings &&
      store.state.config.organization_loyalty_settings
        .allow_loyalty_subscriptions
    )
  ) {
    next(from.meta.subscriptionLicenseRequired ? from : { name: main_page });
    return;
  }
  if (
    to.meta.requiresTransactionsTabVisible &&
    store.state.config.organization_loyalty_settings &&
    store.state.config.organization_loyalty_settings.hide_transactions === true
  ) {
    next(from.meta.requiresTransactionsTabVisible ? from : { name: main_page });
    return;
  }
  if (
    to.meta.invoicesShouldBeEnabled &&
    homeLoaded &&
    !store.state.user.expects_invoices
  ) {
    next(from.meta.invoicesShouldBeEnabled ? from : { name: main_page });
    return;
  }

  if (
    to.meta.webshopLicenseRequired &&
    store.state.config.webshop_configuration === null
  ) {
    if (localStorage.getItem("authorized")) {
      next({ name: main_page });
      return;
    }
    next({ name: "organization-not-found" });
    return;
  }

  // If only_for_integrator is enabled, only webshop
  if (
    store.state.config.webshop_configuration !== null &&
    store.state.config.webshop_configuration.mode === "enabled_for_integrator"
  ) {
    if (
      to.name !== "webshop-redirect-no-login" &&
      to.name !== "webshop-integrator-order" &&
      to.name !== "organization-not-found" &&
      to.name !== "termsandconditions" &&
      to.name !== "privacystatement"
    ) {
      next({ name: "organization-not-found" });
      return;
    }
  } else {
    if (
      to.meta.webshopLicenseRequired &&
      store.state.config.webshop_configuration !== null &&
      store.state.config.webshop_configuration.mode !== "enabled"
    ) {
      if (!localStorage.getItem("authorized")) {
        next({ name: "organization-not-found" });
        return;
      }
      next(from.meta.webshopLicenseRequired ? from : { name: main_page });
      return;
    }
  }

  //if homedata not loaded, load it
  if (
    to.meta.authRequired &&
    localStorage.getItem("authorized") &&
    !homeLoaded
  ) {
    homeLoaded = true;
    next({
      path: to.name !== "loading" ? "/loading/" + to.name : "/" + main_page
    });
    return;
  }

  //logout
  if (!to.meta.authRequired) {
    homeLoaded = false;
  }
  next();
});

function layoutDir() {
  return store.state.config.template_settings.layout;
}

export default router;
